/* eslint-disable react/prop-types */
import React from 'react';
import numeral from 'numeral';
import { map } from 'lodash';
import { Link } from 'react-router-dom';

export const formatUnairedShows = ({ data = [], fields = {} } = {}) =>
  map(data, show => ({
    show: show[fields.show],
    showId: show[fields.showId],
    network: show[fields.network],
    networkId: show[fields.networkId],
    followers: show[fields.followers],
    releaseDate: show[fields.releaseDate]
  }));

export const formatReturningShows = ({ data = [], fields = {} } = {}) =>
  map(data, show => ({
    show: show[fields.show],
    showId: show[fields.showId],
    network: show[fields.network],
    networkId: show[fields.networkId],
    followers: show[fields.followers],
    releaseDate: show[fields.releaseDate],
    followerGrowth: show[fields.followerGrowth]
  }));

export const unairedDefaultSorts = ['followers'];
export const returningDefaultSorts = ['followers'];

export const unairedColumns = [
  {
    Header: '',
    accessor: (row, i) => i + 1,
    id: 'index',
    className: 'tvt-tabular-data-table__rank'
  },
  {
    Header: 'Show',
    accessor: 'show',
    className: 'tvt-tabular-data-table__item-name',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/show/${original.showId}`}>{value}</Link>
    )
  },
  {
    Header: 'Network',
    accessor: 'network',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/network/${original.networkId}`}>{value}</Link>
    ),
    className: 'tvt-tabular-data-table__show-anticipation-new-network'
  },
  {
    Header: 'Release Date',
    accessor: 'releaseDate',
    className: 'tvt-tabular-data-table__show-anticipation-new-release-date'
  },
  {
    Header: 'Followers',
    accessor: 'followers',
    Cell: ({ cell: { value } }) => numeral(value).format('0,0'),
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-anticipation-new-followers',
    sortDescFirst: true,
    hoverTitle:
      'Number of users who expressed interest or intent to view a specific show or movie by adding it to their watch list'
  }
];

export const returningColumns = [
  {
    Header: '',
    accessor: (row, i) => i + 1,
    id: 'index',
    className: 'tvt-tabular-data-table__rank'
  },
  {
    Header: 'Show',
    accessor: 'show',
    className: 'tvt-tabular-data-table__item-name',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/show/${original.showId}`}>{value}</Link>
    )
  },
  {
    Header: 'Network',
    accessor: 'network',
    className: 'tvt-tabular-data-table__show-anticipation-return-network',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/network/${original.networkId}`}>{value}</Link>
    )
  },
  {
    Header: 'Upcoming Season Release Date',
    accessor: 'releaseDate',
    className:
      'tvt-tabular-data-table__show-anticipation-return-release-date caret-center'
  },
  {
    Header: 'New Followers',
    accessor: 'followers',
    Cell: ({ cell: { value } }) => numeral(value).format('0,0'),
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-anticipation-return-followers',
    sortDescFirst: true,
    hoverTitle:
      'Number of users who expressed interest or intent to view a specific show or movie by adding it to their watch list'
  },
  {
    Header: 'New Follower Growth %',
    accessor: 'followerGrowth',
    Cell: ({ cell: { value } }) => `${numeral(value * 100).format('0.00')}%`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-anticipation-return-growth caret-center',
    sortDescFirst: true
  }
];

export default {
  unairedColumns,
  formatUnairedShows,
  formatReturningShows,
  unairedDefaultSorts
};
